import { render } from "./workflowDeal.vue?vue&type=template&id=2361540f&scoped=true"
import script from "./workflowDeal.vue?vue&type=script&lang=js"
export * from "./workflowDeal.vue?vue&type=script&lang=js"

import "./workflowDeal.vue?vue&type=style&index=0&id=2361540f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2361540f"]])

export default __exports__